import { getHostbaseUrl } from '@core/tools';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { ETimeRange, IAirBillingData, ICombinationStatData, IDisburseStatistics, IFlexWorkStatistics, ILianLianBilling, IMessageNotice, IOrderStatisticsData, ITaskStatistics, IYeepayBilling } from '../types/home';

const hostUrl = getHostbaseUrl();

/**
 * 首页 - 消息通知
 */
export async function queryMessagess() {
  let data = [] as IMessageNotice[];

  try {
    const { code, context, message } = await Http.get<IMessageNotice[] | IMessageNotice>(
      `${hostUrl}/base/homepage/message-list`,
      {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      if (Array.isArray(context)) {
        data = context || [] as IMessageNotice[];
      } else {
        data = !!context ? [context] as IMessageNotice[] : [];
      }
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 首页 - 智慧分账 - 数据统计
 */
export async function queryAirBillingData() {
  let data = {} as IAirBillingData;

  try {
    const { code, context, message } = await Http.get<IAirBillingData>(
      `${hostUrl}/pay/homepage/air-billing`,
      {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IAirBillingData;

      data.lianLian = data.lianLian || {} as ILianLianBilling;
      data.yeepay = data.yeepay || {} as IYeepayBilling;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 首页 - 智慧分账 - 统计数据
 */
export async function queryOrderStatisticsData(timeRange = ETimeRange.WEEK) {
  let data = {} as IOrderStatisticsData;

  try {
    const { code, context, message } = await Http.post<IOrderStatisticsData>(
      `${hostUrl}/pay/agg/order/statistics`,
      { timeRange },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IOrderStatisticsData;

      data.crowdOrder = data.crowdOrder || {} as IFlexWorkStatistics;
      data.matchOrder = data.matchOrder || {} as IFlexWorkStatistics;
      data.disburseOrder = data.disburseOrder || {} as IDisburseStatistics;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询组合统计数据
 */
export async function queryCombinationStatistics(): Promise<ICombinationStatData> {
  let data = {} as ICombinationStatData;

  try {
    const { code, context, message } = await Http.post<ICombinationStatData>(
      `${hostUrl}/pay/agg/order/combination-statistics`,
      {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as ICombinationStatData;

      data.matchStatistics = data.matchStatistics || {} as ITaskStatistics;
      data.crowdStatistics = data.crowdStatistics || {} as ITaskStatistics;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
